import { environment } from '@/helpers/Environment';
import { i18n } from '@/app/I18n';
import store from '@/store/store';
export function eventListingTitle() {
    const t = languageItem('eventListingRoute');
    return store.getters['Cart/cartHasItems'] ? t.upsellsTitle : t.title;
}
export function changeMemberDetailsInstructions() {
    return (environment.portalStrings.change_member_details_instructions ??
        'To change your membership details, please contact us.');
}
/**
 * Use LanguageStrings interface/type when accessing i18n language properties.
 */
export function languageItem(key) {
    return i18n.t(key);
}
export function reserveLanguage(name) {
    return {
        ...languageItem('reserve'),
        // Allow the more specific key to override the more generic key.
        ...languageItem(name),
    };
}
